<template>
  <b-card class="text-center border border-danger">
    <b>Draft reports do not show this content.</b> <br>
    This content will be available once the product is on the site.
  </b-card>
</template>

<script>

import { BCard } from 'bootstrap-vue'

export default {
  name: 'DraftBlockingOverlay',
  components: {
    BCard,
  },
}
</script>
